export default __webpack_public_path__ + "static/media/personal8.77787e79.jpeg";